import { HttpErrorResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { NotificationPreferences } from '../models/notification-preferences.model';
import { ContextService } from '../services/context.service';
import { NotificationPreferencesService } from '../services/notification-preferences.service';

export function notificationPreferencesCompanyName(
  preferences: NotificationPreferences,
  selectedClientName?: string | null
): string | null {
  return preferences.masterClientName || selectedClientName || null;
}

export function notificationPreferencesValidationError(err: HttpErrorResponse): string | null {
  if (typeof err.error !== 'object' || err.error === null) {
    return null;
  }
  const body = err.error as { error?: unknown; message?: unknown };
  if (typeof body.error === 'string') {
    return body.error;
  }
  if (typeof body.message === 'string') {
    return body.message;
  }
  return null;
}

/** True when the user has no saved rows for this MCode and can configure at least one type. */
export function needsNotificationSetupPrompt(preferences: NotificationPreferences): boolean {
  if (preferences.hasConfiguredPreferences) {
    return false;
  }
  return (
    preferences.billingEnabled !== null ||
    preferences.enrollmentEnabled !== null ||
    preferences.cancellationEnabled !== null
  );
}

/**
 * When 201 already set pending, skip the GET. Otherwise load prefs for mCode and set pending if unset.
 * GET failure leaves pending false so login is not blocked.
 */
export async function evaluatePendingNotificationSetupIfNeeded(
  contextService: ContextService,
  notificationPreferencesService: NotificationPreferencesService,
  mCode: string | null | undefined
): Promise<void> {
  if (contextService.isPendingNotificationSetup() || !mCode) {
    return;
  }

  try {
    const preferences = await firstValueFrom(
      notificationPreferencesService.getByMCode(mCode).pipe(timeout(20000))
    );
    contextService.setPendingNotificationSetup(needsNotificationSetupPrompt(preferences));
  } catch {
    // Leave pending false; do not block login.
  }
}

